export const environment = {
  production: false,
  APP_NAME: 'Store Management',
  BASE_URL: 'https://stage-api-ws-om.relinns.website/',
  // BASE_URL: 'http://192.168.1.44:13001/',
  VERSION: '1.0.0',
  SECRET_KEY: "ecom@2025",
  ENCRYPTION_KEY: "BKRe0bP+5g8Ocu6avo5lRcZIzWiRq1Fw5/8NLu3PfPQ=",
  CDN_URL: 'https://dev-botpenguin.s3.us-east-2.amazonaws.com/cdn',
  STORE_BASE_URL: 'https://stage-web-ws-om.relinns.website/',
  BP_URL: 'https://e1-api.botpenguin.com'
};
